import React from 'react';
import {observer} from "mobx-react";
import {KeyboardArrowUp} from "../../../../../core/icons/keyboard-arrow/keyboard-arrow-up";
import {KeyboardArrowDown} from "../../../../../core/icons/keyboard-arrow/keyboard-arrow-down";
import {BETTING_CONTAINER} from "../../../betting-container-consts";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export const BettingZoneDrawerMenuItemAccordionArrow = observer(({item, expandedItemId}) => {
  const isAccordionItem: Boolean = item.viewType === BETTING_CONTAINER.MENU_VIEW_TYPE.accordion;

  const assetsColor = useThemeColor(COLORS.textPrimary);

  const arrowProps = {
    color: assetsColor,
    style: {
      fill: assetsColor,
      width: 20,
      height: 20
    }
  }

  return isAccordionItem ? (expandedItemId === item.id ? <KeyboardArrowUp {...arrowProps}/> : <KeyboardArrowDown  {...arrowProps}/>) : null
});